import posthog from 'posthog-js';

// No key (local dev) → PostHog never initializes and no traffic is sent.
if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2025-05-24',
    capture_exceptions: true,
    // Decks and files carry confidential IB deal data: mask everything.
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
      // rrweb still traverses an iframe blocked directly by blockSelector.
      // The preview wrappers use this class to stop traversal before the iframe.
      blockClass: 'ph-no-capture',
      blockSelector: 'canvas, iframe',
    },
  });
}
